import React from "react";
import "./InsightsList.scss"

const InsightsList = ({ header, icon, iconColor, subheader }) => {
    return (
        <div className="InsightsList">
            <div className={iconColor === "green" ? "InsightsList-icon-green " : "InsightsList-icon-blue"}>
                <img alt="" src={icon} />
            </div>
            <div className="InsightsList-right">
                <div className="InsightsList-right-header">
                    {header}
                </div>
                <div className="InsightsList-right-subheader">
                    {subheader}
                </div>
            </div>
        </div>
    )
}
export default InsightsList